import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { ChangeEvent as ReactChangeEvent } from 'react';
import { useController } from 'react-hook-form';

interface CheckBoxFieldProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  label: string;
  defaultValue?: string;
}
export function CheckBoxField({ name, label, defaultValue = '' }: CheckBoxFieldProps) {
  const {
    field: { value, onChange },
  } = useController({
    name,
    defaultValue,
  });

  const handleChange = (event: ReactChangeEvent<HTMLInputElement>) => {
    const option = event.target.name;
    const newValue = option === value ? '' : option;
    onChange(newValue);
  };
  return (
    <FormGroup row>
      <FormControlLabel
        control={<Checkbox checked={Boolean(value)} onChange={handleChange} name={name} />}
        label={label}
      />
    </FormGroup>
  );
}
